<style scoped>
.btn-outline-secondary{
  border-color: #ced4da;
  color:#181818
}
</style>
<script>
import { notify } from '@/helpers/notify' 
import {
  requiredIf
} from "vuelidate/lib/validators";

export default {
    props:[
        "data",
        "subs_id",
        "type",
        "referans",

        "id",
        "assigned_userid",
        "appointment_at",
        "content",
        "update",

        "randevu",
        "tech_id",
        "group"
    ],
    data() {
        return {
            submitted: false,
            personelList:[],
            groupList:[],
            ilList : [],
            ilceList : [],
            bucakList : [],
            form:{},
            titles:[ 
              "KURULUM",
              "SÖKÜM",
              "ARIZA",
              "TAŞIMA",
              "KEŞİF"
            ],
        };
    },
    validations: {
      form: {
        group: {  
          required:requiredIf(function () {
            return !this.form.type == 4
          })  
        },
      }
    },
    computed:{
      ModalTitle(){ 
        return this.randevu == true ? 'Randevu Ver' : `YENİ ${this.titles[this.type -1 ]} ${this.update ? 'GÜNCELLE' : '' }`  
      },
      statusList(){
        let type = 'montaj'
        if(this.form.type == 3 ){
          type = 'ariza'
        }
        const result = this.status.filter(e=>{
            return e.type == type
        })
        
        return result
      },
      dnow(){
        const now = new Date();
        return this.appoitmentFormat(now)
      }
    },
    watch:{
        data(){

          if(this.referans == 'search'){
             this.form.appointment_at = null
          }else{
            this.form.appointment_at = this.dnow
          }

          this.form = { 
              ...this.form, 
              subs_id:this.subs_id, 
              type: this.type, 
              referans:this.referans ?? null,
              randevu:this.randevu,
              id:this.tech_id
            }
      
          this.getUsers()

          if(this.type == 3){
            this.getGroups()
          }

          if(this.type == 4){
            this.setSelected({ id : 0},'il')
          }

        },
        update(props){
        
            this.form = {}
            const {
                id, 
                appointment_at, 
                assigned_userid, 
                content, 
                type,
                group
              } = this

            this.form = Object.assign( {  
                id, 
                appointment_at, 
                assigned_userid, 
                content, 
                type,
                group
              }, 
              this.form)  

        
          
          if(props.type == 1) // kurulum
            this.form = Object.assign( this.form)  
          
          if(props.type == 3 || this.type == 3)
            this.getGroups()
            
          if(props.type == 4)
            this.setSelected({ id : 0},'il')

      
          if(!this.form.referans)
            this.getUsers()
          
        }
    },
    methods: {
      appoitmentFormat(now){
        const year = now.getFullYear();
        const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
        const day = now.getDate().toString().padStart(2, '0');
        const hours = now.getHours().toString().padStart(2, '0');
        const formattedDateTime = `${year}-${month}-${day}T${hours}:00`;
        return formattedDateTime;
      },

      async setSelected(val,event){
          const object = event + 'List' 
          const { id } = val
          const response = await this.$http.post(`/address/${event}/${id}`)
          if(response.data.error) return;
          this[object] = response.data;
      },
      close(){
          this.$parent.$bvModal.hide('setup')
      },
      getUsers(){
        this.$http.get('/technic-service/listServicePersonel')
        .then(resp => this.personelList = resp.data.content)
      },
      getGroups(){
          this.$http.post('/technic-service/group')
          .then(resp => {
              let arr= resp.data
              arr.unshift({ id: "", name: "Seçiniz " });
              this.groupList  = arr
          })
      },
      handleSubmit(){
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) { return; } 

       if(this.form.id){
         if(this.randevu){
            this.$http.post('technic-service/assign', this.form)
              .then(resp => {
                  notify.success(resp.data.message)
                  this.$emit('loadItems')
                  this.close()
              })
          }else{
             this.$http.post('/technic-service/update/' + this.form.id, this.form)
              .then(resp => {
                  notify.success(resp.data.message)
                  this.$emit('loadItems')
                  this.close()
              })
          }

           
        }else{
          this.$http.post('/technic-service/store', this.form)
            .then(resp => {
              this.$emit('loadItems')
              if(resp.data.code == 100){
                notify.success(resp.data.message)
                this.close()
              }else{
                notify.error(resp.data.message)
              }
              this.close()
            })
        }
        this.submitted = false;
      },
      today(){
        const now = new Date();
        this.form.appointment_at = this.appoitmentFormat(now)
      },
      tomorrow(){
        const now = new Date();
        const tomorrow = new Date(now);
        tomorrow.setDate(now.getDate() + 1);
        this.form.appointment_at = this.appoitmentFormat(tomorrow)
      },
      nextday(){
        const now = new Date();
        const tomorrow = new Date(now);
        tomorrow.setDate(now.getDate() + 2);
        this.form.appointment_at = this.appoitmentFormat(tomorrow)
      }
    },
};
</script>

<template> 
<b-modal id="setup" :title="ModalTitle"  no-close-on-backdrop hide-footer>
  <form @submit.prevent="handleSubmit">
    <div class="row" v-if="!form.referans">  
      <div class="col-12"> 
        <div class="mb-3">
          <label for="appointment_at">Randevu Tarihi</label>
          <div class="input-group mb-3">
            <b-form-input
              v-model="form.appointment_at"
              id="appointment_at"
              type="datetime-local"
              :min="dnow"
            ></b-form-input>
            <button class="btn btn-outline-secondary" type="button" @click="today">Bugun</button>
            <button class="btn btn-outline-secondary" type="button" @click="tomorrow">Yarın</button>
            <button class="btn btn-outline-secondary" type="button" @click="nextday" >Sonraki Gün</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="!form.type">
      <div class="col-12">
        <div class="mb-3">
            <label>İşlem</label>
            <select v-model="form.type" class="form-select">
                <option value="">Lütfen Seçiniz</option>
                <option value="1">KURULUM</option>
                <option value="2">SÖKÜM</option>
                <option value="3">ARIZA</option>
                <option value="4">TAŞIMA</option>
                <option value="5">KEŞİF</option>
            </select>
        </div>
      </div> 
    </div>
    <div class="row" v-if="form.type == 3 && !randevu">
      <div class="col-12">
        <div class="mb-3">
            <label>Arıza Tanımı</label>
            <v-select 
              v-model="form.group"
              :options="groupList"
              :reduce="form => form.id"
              :class="{ 'is-invalid': submitted && $v.form.group.$error }" 
              label="name">
            <span slot="no-options">Sonuç Bulunamadı</span>
            </v-select>
            <div
                v-if="submitted && !$v.form.group.required"
                class="invalid-feedback">
                Bu alanı doldurmak zorunludur.
            </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="form.type == 4 && !randevu">
      <div class="col-12">
        <div class="mb-3">
            <label>İşlem</label>
            <select v-model="form.tasimatipi" class="form-select">
                <option value="1">Tam Taşıma</option>
                <option value="2">Yarım Taşıma</option>
            </select>
        </div>
      </div> 
    </div>
    <div class="row" v-if="form.type == 4 && !randevu">
      <div class="col-md-6">
        <div class="mb-3"> 
          <label for="province">İlçe</label>
            <v-select
              label="name" 
              v-model="form.province"
              :options="ilList" 
              :reduce="country => country.id"
                @option:selecting="setSelected($event,'bucak')"><span slot="no-options">Sonuç Bulunamadı</span>
          </v-select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label for="township">Bölge</label>
            <v-select 
            label="name"  
            v-model="form.township"                    
            :options="bucakList" 
            :reduce="country => country.id"
            ><span slot="no-options">Sonuç Bulunamadı</span>
          </v-select>
        </div>
      </div>
    </div>
    <div class="row" v-if="form.type == 4 && !randevu">
      <div class="col-12">
        <div class="mb-3">
            <label>Kurulum Adresi</label>
            <textarea
                v-model="form.address"
                type="text"
                class="form-control"
              />
        </div>
      </div>
    </div>
    <div class="row" v-if="((form.type == 1 || form.type == 2 || form.type == 3 || form.type == 4) && !form.referans)">
      <div class="col-12">
        <div class="mb-3">
            <label>Atanacak Personel</label>
            <v-select
                label="name" 
                v-model="form.assigned_userid"
                :options="personelList" 
                :reduce="data => data.id">
                <span slot="no-options">Sonuç Bulunamadı</span>
            </v-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="mb-3">
            <label>Açıklama</label>
            <textarea
                v-model="form.content"
                type="text"
                class="form-control"
              />
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-3">
        <b-button variant="light" @click="close()">Vazgeç</b-button>
        <b-button 
            v-if="form.id"
            type="submit" 
            variant="warning" 
            class="ms-1"
            >Güncelle
        </b-button>
        <b-button 
            v-else
            type="submit" 
            variant="success" 
            class="ms-1"
            >Oluştur
        </b-button>
    </div>
  </form>
</b-modal>
</template>